import { render, staticRenderFns } from "./chargebackList.vue?vue&type=template&id=005b4d95&scoped=true&"
import script from "./chargebackList.vue?vue&type=script&lang=js&"
export * from "./chargebackList.vue?vue&type=script&lang=js&"
import style0 from "./chargebackList.vue?vue&type=style&index=0&id=005b4d95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b4d95",
  null
  
)

export default component.exports